import React from 'react';
import { useState, useRef, useEffect } from "react";
import { Link, useNavigate, handleNavigation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { Container, Row, Col, Button } from "react-bootstrap";
import { ArrowUpRight } from "react-feather"; // Using react-feather for the arrow icon
import { FaArrowDown, FaEnvelope } from "react-icons/fa"; // For the envelope icon in the button
import SubscribeIcon from "../images/explore.png"; // Adjust the path to your circular icon image
import { FaWhatsapp } from "react-icons/fa";
import { MdKeyboardArrowRight } from "react-icons/md";
// import BenefitsImage from '../images/why-img.jpeg';
import EnvisionOne from '../images/envision-one.png'
import EnvisionTwo from '../images/envision-two.png'
import WhyRight from '../images/why-right.png';
import WhyPremierGif from "../images/why-premier-gif-usa.gif"
// Top Prouducts Series
import { FaChevronDown } from "react-icons/fa"; // For the chevron-down icon in the button
// Top Prouducts Series
// Benefits Starts
import BenefitOne from '../images/ben-1.png'
import BenefitTwo from '../images/ben-2.png'
import BenefitThree from '../images/ben-3.png'
import HighQualityIcon from "../images/highlights/quality.png"; // Adjust the path to your image
import OnTimeDeliveryIcon from "../images/highlights/delivery.png"; // Adjust the path
import ClientsIcon from "../images/highlights/globe.png"; // Adjust the path
import ComplianceIcon from "../images/highlights/complete.png"; // Adjust the path
// Benefits Ends
// Import the images for the section
import FieldServicesIcon from "../images/services/field-service.png"; // Adjust the path to your image
import VacuumSystemIcon from "../images/services/vaccum.png"; // Adjust the path
import MaintenanceRepairIcon from "../images/services/maintenance.png"; // Adjust the path
import CommissioningTrainingIcon from "../images/services/commisioning.png"; // Adjust the path
import './script'
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useLocation } from "react-router-dom";
import { Mail, Phone, User } from "lucide-react"; // Assuming you're using lucide icons
import FullScreenLoader from "../components/FullScreenLoader";



function Home() {
    const location = useLocation();

    useEffect(() => {
        const sectionId = location.state?.scrollTo;
        if (sectionId) {
            const el = document.getElementById(sectionId);
            if (el) {
                el.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]);

    //
    const [showFormPopup, setShowFormPopup] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [showThankYouPopup, setShowThankYouPopup] = useState(false);
    const [pendingBrochure, setPendingBrochure] = useState(null);


    const handleReachOut = (context) => {
        setPendingBrochure(null);
        setResponseMessage("");
        setShowFormPopup(true);
        setFormSubmitted(false); // Reset form submission when opening popup
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        // You can add form validation or API call here
        setFormSubmitted(true);
    };


    // 

    // Form PHP
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phone: "",
        message: "",
    });

    const [responseMessage, setResponseMessage] = useState("");
    const [loading, setLoading] = useState(false);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setResponseMessage("");

        // Optional: basic validation
        if (!formData.fullName || !formData.email || !formData.phone || !formData.message) {
            setResponseMessage("Please fill in all fields.");
            setLoading(false);
            return;
        }

        const formBody = new URLSearchParams(formData).toString();

        try {
            const response = await fetch("https://peracause.com/backend-files/premier-pumps-usa/contact-form-premier-pumps.php", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: formBody,
            });

            const result = await response.json();

            if (result.status === "success") {
                setResponseMessage("Message sent successfully! ✅");
                setFormData({
                    fullName: "",
                    email: "",
                    phone: "",
                    message: "",
                });
                if (pendingBrochure) {
                    const brochureToDownload = pendingBrochure;
                    setShowThankYouPopup(false);
                    setShowFormPopup(false);
                    setPendingBrochure(null);
                    triggerBrochureDownload(brochureToDownload);
                    const formId = brochureToDownload.formId || "product";
                    navigate(`/thank-you?formId=${encodeURIComponent(formId)}`, {
                        state: {
                            brochureUrl: brochureToDownload.url,
                            brochureName: brochureToDownload.filename,
                        },
                    });
                } else {
                    setShowFormPopup(false); // close form
                    setShowThankYouPopup(true); // open thank-you popup
                }
            } else {
                setResponseMessage("Error: " + result.message);
            }
        } catch (error) {
            setResponseMessage("Error sending message. Please try again.");
        } finally {
            setLoading(false);
        }




    };
    // Form PHP

    const toFormId = (name) => {
        const base = String(name || "")
            .trim()
            .toLowerCase()
            .replace(/&/g, "and")
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/(^-|-$)/g, "");
        return base || "product";
    };

    const resolveBrochureFilename = (brochureUrl, brochureName) => {
        if (brochureName) return brochureName;
        if (!brochureUrl) return "brochure.pdf";
        const cleanUrl = String(brochureUrl).split(/[?#]/)[0];
        const lastSegment = cleanUrl.split("/").pop();
        return decodeURIComponent(lastSegment || "brochure.pdf");
    };

    const openBrochureForm = (brochureUrl, brochureName, productName) => {
        setResponseMessage("");
        setPendingBrochure({
            url: brochureUrl,
            filename: resolveBrochureFilename(brochureUrl, brochureName),
            formId: toFormId(productName),
        });
        setShowFormPopup(true);
    };

    const closeBrochureForm = () => {
        setResponseMessage("");
        setShowFormPopup(false);
        setPendingBrochure(null);
    };

    const triggerBrochureDownload = (brochure) => {
        if (!brochure?.url) return;
        const link = document.createElement("a");
        link.href = brochure.url;
        if (brochure.filename) {
            link.setAttribute("download", brochure.filename);
        }
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    // newsletter form 
    const [newsletterEmail, setNewsletterEmail] = useState("");
    const [newsletterStatus, setNewsletterStatus] = useState("");

    const handleNewsletterSubmit = async (e) => {
        e.preventDefault();
        setNewsletterStatus("Submitting...");

        try {
            const formData = new FormData();
            formData.append("email", newsletterEmail);

            const response = await fetch("https://peracause.com/backend-files/premier-pumps-usa/newsletter-premier-pumps.php", {
                method: "POST",
                body: formData,
            });

            if (response.ok) {
                setNewsletterStatus("✅ Successfully subscribed!");
                setNewsletterEmail("");
            } else {
                setNewsletterStatus("❌ Subscription failed. Please try again.");
            }
        } catch (error) {
            console.error("Newsletter Error:", error);
            setNewsletterStatus("⚠️ An error occurred. Please try again later.");
        }
    };

    // newsletter form 

    const navigate = useNavigate();
    const handleNavigation = () => {
        navigate("/products"); // Adjust the path as per your route
    };

    // Top Products Starts
    const products = [
        { id: 1, image: require("../images/products/PV-SERIES.png"), name: "PV Series", category: "pv" },
        { id: 2, image: require("../images/products/PREMIER-SERIES.png"), name: "PREMIER Series", category: "premier" },
        { id: 3, image: require("../images/products/PS-SERIES.png"), name: "PVSC Series", category: "ps" },
        { id: 4, image: require("../images/products/PXL-SERIES.png"), name: "PVXL Series", category: "pvxl" },
        { id: 5, image: require("../images/products/P2BE-SERIES.png"), name: "P2BE Series", category: "p2be" },
        { id: 6, image: require("../images/products/P501-SERIES.png"), name: "P501 Series", category: "p501" },
        { id: 7, image: require("../images/products/PVW-SERIES.png"), name: "PWS Series", category: "pws" },
        { id: 8, image: require("../images/products/PA-140-SERIES.png"), name: "PA Series", category: "pa" },
        { id: 9, image: require("../images/products/PAT-SERIES.png"), name: "PAT Series", category: "pat" },
        { id: 10, image: require("../images/product/PSHR SERIES.png"), name: "PSHR Series", category: "pshr" },
        { id: 11, image: require("../images/products/PTC-SERIES.png"), name: "PTC Series", category: "ptc" },
        { id: 12, image: require("../images/products/PLH -SERIES.png"), name: "PLH Series", category: "plh" },
        { id: 13, image: require("../images/products/WXP-SERIES.png"), name: "WXP Series", category: "wxp" },
        { id: 14, image: require("../images/products/P9000-SERIES.png"), name: "P9000", category: "p9000" },
        { id: 15, image: require("../images/products/SPARES.png"), name: "SPARES", category: "pv" },
    ]

    const [visibleItems, setVisibleItems] = useState(8); // Default for lg screens

    useEffect(() => {
        const updateVisibleItems = () => {
            const width = window.innerWidth;
            if (width >= 992) setVisibleItems(8); // Large screens
            else if (width >= 768) setVisibleItems(6); // Medium screens
            else setVisibleItems(4); // Small screens
        };

        updateVisibleItems(); // Set initial value
        window.addEventListener("resize", updateVisibleItems);

        return () => window.removeEventListener("resize", updateVisibleItems);
    }, []);
    // Top Products Ends
    // Envision Carousel
    useEffect(() => {
        const bootstrap = require("bootstrap");
        const carouselElement = document.getElementById("carouselExampleIndicators");
        new bootstrap.Carousel(carouselElement, {
            interval: 5000, // 3 seconds
            touch: true, // Enables smooth touch gestures
            ride: "carousel",
            pause: false,
        });
    }, []);
    // Envision Carousel
    // Prodcuts Series Starts

    const swiper1Ref = useRef(null);
    const swiper2Ref = useRef(null);

    // Function to attach hover events
    const attachHoverEvents = (swiperRef) => {
        if (swiperRef.current && swiperRef.current.el) {
            swiperRef.current.el.addEventListener("mouseenter", () => swiperRef.current.autoplay.stop());
            swiperRef.current.el.addEventListener("mouseleave", () => swiperRef.current.autoplay.start());
        }
    };

    // Attach event listeners when Swiper initializes
    useEffect(() => {
        if (swiper1Ref.current) attachHoverEvents(swiper1Ref);
        if (swiper2Ref.current) attachHoverEvents(swiper2Ref);
    }, []);

    useEffect(() => {
        if (swiper1Ref.current && swiper1Ref.current.swiper) {
            swiper1Ref.current.swiper.params.navigation.prevEl = ".prev1";
            swiper1Ref.current.swiper.params.navigation.nextEl = ".next1";
            swiper1Ref.current.swiper.navigation.init();
            swiper1Ref.current.swiper.navigation.update();
        }

        if (swiper2Ref.current && swiper2Ref.current.swiper) {
            swiper2Ref.current.swiper.params.navigation.prevEl = ".prev2";
            swiper2Ref.current.swiper.params.navigation.nextEl = ".next2";
            swiper2Ref.current.swiper.navigation.init();
            swiper2Ref.current.swiper.navigation.update();
        }
    }, []);

    const swiperRef = useRef(null);
    const productItems1 = [
        {
            id: 1,
            image: require("../images/products/PV-SERIES.png"),
            name: "PV SERIES",
            capacity: {
                prefix: "Capacity :<br /> 85 CFM TO 11,385 CFM",
                suffix: "145 m³/h to 19,345 m³/h",
            },
            brochure: require("../images/new-brochures/Single-Stage Liquid Ring Vacuum Pumps_PV Series.pdf"),
            brochureName: "Single-Stage Liquid Ring Vacuum Pumps_PV Series.pdf",
            category: "pv",
        },
        {
            id: 2,
            image: require("../images/products/PREMIER-SERIES.png"),
            name: "PREMIER SERIES",
            capacity: {
                prefix: "Capacity :<br /> 2,360 CFM to 13,225 CFM",
                suffix: "4,010 m³/h to 22,470 m³/h",
            },
            brochure: require("../images/new-brochures/Single-Stage Liquid Ring Vacuum Pumps_PREMIER Series.pdf"),
            brochureName: "Single-Stage Liquid Ring Vacuum Pumps_PREMIER Series.pdf",
            category: "premier",
        },
        {
            id: 3,
            image: require("../images/products/PS-SERIES.png"),
            name: "PVSC SERIES",
            capacity: {
                prefix: "Capacity :<br /> 70 CFM to 1,315 CFM",
                suffix: "120 m³/h to 2,235 m³/h",
            },
            brochure: require("../images/new-brochures/Single-Stage Liquid Ring Vacuum Pumps_PVSC Series.pdf"),
            brochureName: "Single-Stage Liquid Ring Vacuum Pumps_PVSC Series.pdf",
            category: "ps",
        },
        {
            id: 4,
            image: require("../images/products/PXL-SERIES.png"),
            name: "PVXL SERIES",
            capacity: {
                prefix: "Capacity :<br /> 60 CFM to 3,510 CFM",
                suffix: "105 m³/h to 5,960 m³/h",
            },
            brochure: require("../images/new-brochures/Single-Stage Liquid Ring Vacuum Pumps_PVXL Series.pdf"),
            brochureName: "Single-Stage Liquid Ring Vacuum Pumps_PVXL Series.pdf",
            category: "pvxl",
        },
        {
            id: 5,
            image: require("../images/products/P2BE-SERIES.png"),
            name: "P2BE SERIES",
            capacity: {
                prefix: "Capacity :<br /> 2,345 CFM  to 42,380 CFM",
                suffix: " 4,000 m³/h to 72,000 m³/h",
            },
            brochure: require("../images/new-brochures/Single-Stage Liquid Ring Vacuum Pumps_P2BE Series.pdf"),
            brochureName: "Single-Stage Liquid Ring Vacuum Pumps_P2BE Series.pdf",
            category: "p2be",
        },
        {
            id: 6,
            image: require("../images/products/P501-SERIES.png"),
            name: "P501 SERIES",
            capacity: {
                prefix: "Capacity :<br /> 2,000 CFM to 19,550 CFM",
                suffix: "3,400  m³/h to 33,215 m³/h",
            },
            brochure: require("../images/new-brochures/Single-Stage Liquid Ring Vacuum Pumps_P501 Series.pdf"),
            brochureName: "Single-Stage Liquid Ring Vacuum Pumps_P501 Series.pdf",
            category: "p501",
        },
        {
            id: 7,
            image: require("../images/products/PVW-SERIES.png"),
            name: "PWS SERIES",
            capacity: {
                prefix: "Capacity :<br /> 105 CFM to 1,265 CFM",
                suffix: "175 m³/h to 2,150 m³/h",
            },
            brochure: require("../images/new-brochures/Single-Stage Liquid Ring Vacuum Pumps_PWS Series.pdf"),
            brochureName: "Single-Stage Liquid Ring Vacuum Pumps_PWS Series.pdf",
            category: "pws",
        },
    ];


    const productItems2 = [
        {
            id: 8,
            image: require("../images/products/PA-140-SERIES.png"),
            name: "PA SERIES",
            capacity: {
                prefix: "",
                suffix: "",
            },
            brochure: require("../images/new-brochures/Two-Stage Liquid Ring Vacuum Pumps_PA Series.pdf"),
            brochureName: "Two-Stage Liquid Ring Vacuum Pumps_PA Series.pdf",
            category: "pa",
        },
        {
            id: 9,
            image: require("../images/products/PAT-SERIES.png"),
            name: "PAT SERIES",
            capacity: {
                prefix: "",
                suffix: "",
            },
            brochure: require("../images/new-brochures/Two-Stage Liquid Ring Vacuum Pumps_PAT Series.pdf"),
            brochureName: "Two-Stage Liquid Ring Vacuum Pumps_PAT Series.pdf",
            category: "pat",
        },
        {
            id: 10,
            image: require("../images/products/PSHR-SERIES.png"),
            name: "PSHR SERIES",
            capacity: {
                prefix: "",
                suffix: "",
            },
            brochure: require("../images/new-brochures/Two-Stage Liquid Ring Vacuum Pumps_PSHR Series.pdf"),
            brochureName: "Two-Stage Liquid Ring Vacuum Pumps_PSHR Series.pdf",
            category: "pshr",
        },
        {
            id: 11,
            image: require("../images/products/PTC-SERIES.png"),
            name: "PTC SERIES",
            capacity: {
                prefix: "",
                suffix: "",
            },
            brochure: require("../images/new-brochures/Two-Stage Liquid Ring Vacuum Pumps_PTC Series.pdf"),
            brochureName: "Two-Stage Liquid Ring Vacuum Pumps_PTC Series.pdf",
            category: "ptc",
        },
        {
            id: 12,
            image: require("../images/products/PLH -SERIES.png"),
            name: "PLH SERIES",
            capacity: {
                prefix: "Capacity :<br /> 70 CFM to 410 CFM",
                suffix: "120 m³/h to 695 m³/h",
            },
            brochure: require("../images/new-brochures/Single-Stage Liquid Ring Vacuum Pumps_PLH Series.pdf"),
            brochureName: "Single-Stage Liquid Ring Vacuum Pumps_PLH Series.pdf",
            category: "plh",
        },
        {
            id: 13,
            image: require("../images/products/WXP-SERIES.png"),
            name: "WXP SERIES",
            capacity: {
                prefix: "",
                suffix: "",
            },
            brochure: require("../images/new-brochures/Dewatering Vacuum Pumps_WXP Series.pdf"),
            brochureName: "Dewatering Vacuum Pumps_WXP Series.pdf",
            category: "wxp",
        },
        {
            id: 14,
            image: require("../images/products/P9000-SERIES.png"),
            name: "P9000",
            capacity: {
                prefix: "Capacity :<br /> 5,750 CFM to 13,570 CFM",
                suffix: "9,770 m³/h to 23,060 m³/h",
            },
            brochure: require("../images/new-brochures/Single-Stage Liquid Ring Vacuum Pumps_P9000 Series.pdf"),
            brochureName: "Single-Stage Liquid Ring Vacuum Pumps_P9000 Series.pdf",
            category: "p9000",
        },
    ];

    // Prodcuts Series Ends
    // Benefits Data
    const benefits = [
        {
            title: "Premier Pump quality",
            description: "Visual appearance, corrosion resistance, color stability, accurate color matching — we put consistent quality first.",
        },
        {
            title: "Speed and efficiency",
            description: "Maximum product availability, prompt fulfillment of requests, streamlined logistics. Performance-oriented approach.",
        },
        {
            title: "Flexibility and service",
            description: "Minimal or no volume restrictions, the ability to customize products, online support — we adapt to market demands and customer needs.",
        },
        {
            title: "Innovation",
            description: "The most modern solutions to enhance our customers' competitiveness. Constantly evolving and bringing innovation from all sectors.",
        },
        {
            title: "Technical support and education",
            description: "Decades of experience to improve employee qualifications and optimize enterprise efficiency. We look at all aspects of our customers’ business to get maximum results.",
        },
    ];
    // Benefits
    // Services Starts

    const services1 = [
        {
            title: "",
            description:
                "Rotor-shaft assemblies are dynamically balanced complying with ISO 1940 G6.3.",
            image: require("../images/faculty/faculty-six.png"),
        },
        {
            title: "",
            description: "Fully equipped and calibrated test facility for Vacuum Pump performance testing as per <br /><span className='fs-12'> B.S. 1571-2:1975 & PNEUROP 6612-1984.</span>",
            image: require("../images/faculty/faculty-eight.jpg"),
        },
        {
            title: "",
            description: `All shaft rounds are inspected for internal defects by ultrasonic testing, complying with <br/> ASTM A388.`,
            image: require("../images/faculty/faculty-three.png"),
        },
        {
            title: "",
            description:
                `Certified personnel for doing in house<br /> Non Destructive Testing.`,
            image: require("../images/faculty/faculty-four.png"),
        },

        {
            title: "",
            description:
                "Rotor-shaft assemblies are dynamically balanced complying with ISO 1940 G6.3.",
            image: require("../images/faculty/faculty-six.png"),
        },
        {
            title: "",
            description: `Fully equipped, calibrated test facility for Vacuum Pump performance testing per B.S. 1571-2:1975 & PNEUROP 6612-1984.`,
            image: require("../images/faculty/faculty-eight.jpg"),
        },
        {
            title: "",
            description: "All shaft rounds are inspected for internal defects by ultrasonic testing, complying with ASTM A388.",
            image: require("../images/faculty/faculty-three.png"),
        },
        {
            title: "",
            description:
                "Certified personal for doing in house Non Destructive Testing.",
            image: require("../images/faculty/faculty-four.png"),
        },



    ];

    const services2 = [

        {
            title: "",
            description: "All pressure retaining components undergo pressure testing at twice the rated operating pressure.",
            image: require("../images/faculty/faculty-five.png"),
        },
        {
            title: "",
            description: "Hardness of castings is controlled to remain within the accepted range, ensuring erosion resistance.",
            image: require("../images/faculty/faculty-two.png"),
        },
        {
            title: "",
            description: "Standard operating procedures are continuously refined to ensure all pumps and parts consistently meet performance requirements.",
            image: require("../images/faculty/faculty-seven.png"),
        },
        {
            title: "",
            description: "Alloy casting grade verification is conducted using a handheld spectrometer.",
            image: require("../images/faculty/faculty-one.png"),
        },

        {
            title: "",
            description: "All pressure retaining components undergo pressure testing at twice the rated operating pressure.",
            image: require("../images/faculty/faculty-five.png"),
        },
        {
            title: "",
            description: "Hardness of castings is controlled to remain within the accepted range, ensuring erosion resistance.",
            image: require("../images/faculty/faculty-two.png"),
        },
        {
            title: "",
            description: "Standard operating procedures are continuously refined to ensure all pumps and parts consistently meet performance requirements.",
            image: require("../images/faculty/faculty-seven.png"),
        },
        {
            title: "",
            description: "Alloy casting grade verification is conducted using a handheld spectrometer.",
            image: require("../images/faculty/faculty-one.png"),
        },

    ];

    // Services Ends
    // Advantage Slide Images
    const advantageItems = [
        { title: "Distillery", image: require("../images/industries/distillery.png") },
        { title: "Meat Processing", image: require("../images/industries/meat-processing.png") },
        { title: "Mining", image: require("../images/industries/mining.png") },
        { title: "Oil & Gas", image: require("../images/industries/oil-rig.png") },
        { title: "Pulp & Paper", image: require("../images/industries/paper-mill.png") },
        { title: "Power Generation", image: require("../images/industries/power-plant.png") },
        { title: "Sugar", image: require("../images/industries/sugar-mill.png") },
        { title: "General Industrial", image: require("../images/industries/General-Industrial.png") },
        { title: " Chemical & Pharmaceutical", image: require("../images/industries/chemcial-and-pharma.png") },
    ];
    // Advantage Slide Images

    // Testimonial Slides
    const testimonials = [
        {
            id: 1,
            logo: require("../images/testimonials/logo/tnpl.png"), // Replace with actual logo path
            text: "PREMIER has developed and supplied spares for Water Ring Vacuum Pump model 15E. The workmanship, quality, and performance of the spares supplied are satisfactory.",
            authorImg: require("../images/testimonials/logo/tnpl.png"), // Replace with actual image path
            authorName: "R. Mani",
            authorRole: "Deputy General Manager (ENGG.) ",
        },
        {
            id: 2,
            logo: require("../images/testimonials/logo/gayatri-paper.png"),
            text: "PREMIER has been regularly supplying us Vacuum Pumps and we are satisfied with their performance.",
            authorImg: require("../images/testimonials/logo/gayatri-paper.png"),
            authorName: "M Rao Varanasi",
            authorRole: "Mill Manager",
        },
        {
            id: 3,
            logo: require("../images/testimonials/logo/melco.png"),
            text: "PREMIER has been supplying spares for Vacuum Pumps, including Body and Rotor Shaft Assemblies with satisfactory performance in several installations including N.T.P.C",
            authorImg: require("../images/testimonials/logo/melco.png"),
            authorName: "Managing Director",
            authorRole: "",
        },
        {
            id: 4,
            logo: require("../images/testimonials/logo/ntpc.png"),
            text: "PREMIER supplied us PV 90 Vacuum Pumps with complete package two years ago for Fly Ash System in our NTPC Simhadri Super Thermal Project and they are running satisfactorily till date.",
            authorImg: require("../images/testimonials/logo/ntpc.png"),
            authorName: "Deputy General Manager",
            authorRole: "A.H.P, N.T.P.C Limited",
        },
        {
            id: 5,
            logo: require("../images/testimonials/logo/apgenco.png"),
            text: "We observed the performance of Vacuum Pumps supplied by PREMIER for our C.A.M-Ash Handling to be satisfactory.",
            authorImg: require("../images/testimonials/logo/apgenco.png"),
            authorName: "Superintendent Engineer",
            authorRole: "O&M, Stage II, R.T.T.P",
        },
        {
            id: 6,
            logo: require("../images/testimonials/logo/ucil.png"),
            text: "We have purchased spares for our existing Vacuum Pumps from PREMIER which were interchangeable with no problems in assembly and performance. ",
            authorImg: require("../images/testimonials/logo/ucil.png"),
            authorName: "Deputy Superintendent ",
            authorRole: "Mechanical",
        },
        {
            id: 7,
            logo: require("../images/testimonials/logo/rayana.png"),
            text: "PREMIER is our go to vendor for all our Vacuum Pump and spare requirements. Their Vacuum Pump packages supplied for our new writing paper project are running well.",
            authorImg: require("../images/testimonials/logo/rayana.png"),
            authorName: "D.P. Srivastava",
            authorRole: "General Manager",
        },
        {
            id: 8,
            logo: require("../images/testimonials/logo/hpgcl.png"),
            text: "We were facing issues with quality and delivery with our Vacuum Pump vendor. PREMIER supported us with an emergency supply of 6 Nos. of Vacuum Pumps which are running satisfactorily.",
            authorImg: require("../images/testimonials/logo/hpgcl.png"),
            authorName: "Superintendent Engineer",
            authorRole: " R.G.T.P.S - Hisar",
        },
        {
            id: 9,
            logo: require("../images/testimonials/logo/parrys.png"),
            text: "PREMIER Vacuum Pump PV 60 is running continuously for more than 10 years now without any repair till date.",
            authorImg: require("../images/testimonials/logo/parrys.png"),
            authorName: "Senior Manager",
            authorRole: "Mechanical",
        },
        {
            id: 10,
            logo: require("../images/testimonials/logo/dcm-sriram.png"),
            text: "PREMIER provided us complete Vacuum Pump packages 3 sets for our compressor application. These pumps are running 24 hours, 7 days a week for more than a year now with no issues in performance. PREMIER guided us technically and provided good service during commissioning of these packages.",
            authorImg: require("../images/testimonials/logo/dcm-sriram.png"),
            authorName: "Senior Manager",
            authorRole: "Mechanical",
        },
    ];
    // Testimonial Slides
    // Writing Items
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    // Define writingItems directly in the component file
    const writingItems = [
        {
            id: 9,
            image: require("../images/latest-writing/news-9.jpg"),
            name: "PV60",
            date: "29 July 2023",
            description: `
      <p>PREMIER is the largest exporter of Liquid Ring Vaccuum Pumps and Spares with installations in more than forty countries.</p>
    `
        },


        {
            id: 3,
            image: require("../images/latest-writing/news-3.jpg"),
            name: "PV60",
            date: "16 November 2024",
            description: `
      <p>PREMIER make P501 M pump equivalent to NASH 904 M arrives in a paper mill in the U.S.A</p>
      <p>Contact PREMIER for your emergency requirements to replace your existing O.E.M Vacuum Pumps and spares.</p>
    `
        },

        {
            id: 2,
            image: require("../images/latest-writing/news-7.jpeg"),
            name: "PV60",
            date: "09 January 2025",
            description: `
      <p>PREMIER offers its unique performance evaluation services for Liquid Ring Vacuum Pumps with minimum pump shutdown time, giving in time failure predictions and minimizing plant shutdown costs due to pump failure.</p>
    `
        },


    ];
    // Writing Items
    // FAQ's

    const faqs = [
        {
            question: "What kind of quality and compliance documentation come along with PREMIER’s products?",
            answer: `
                Upon request, for every one of its products, PREMIER can provide:
                <ul>
                    <li>Manufacturer and third-party lab material grade test certificate</li>
                    <li>Third-party lab test certificate for shaft ultrasonic defect detection</li>
                    <li>Dynamic balancing test certificate for rotor shaft assemblies</li>
                    <li>Pressure test certificate</li>
                    <li>Pump performance test certificate</li>
                    <li>Certificate of Origin and free trade agreement compliance documentation for export sales</li>
                </ul>
            `,
        },
        {
            question: "Can PREMIER supply pumps and spares that are interchangeable with other Liquid Ring Vacuum Pump manufacturers?",
            answer:
                "Yes, PREMIER can custom manufacture pumps and spares that are 100% interchangeable with most other Liquid Ring Vacuum Pump manufacturers. Contact PREMIER to know more about this.",
        },
        {
            question: "What is PREMIER’s delivery time on Liquid Ring Vacuum Pumps and spares?",
            answer:
                "Depending on the material of construction, PREMIER can supply Liquid Ring Vacuum Pumps and spares with delivery times ranging from ready stock to 6 weeks.",
        },
        {
            question: "Can PREMIER provide support for installation and operation of their Liquid Ring Vacuum Pumps?",
            answer:
                "Every PREMIER Liquid Ring Vacuum Pump comes with an exhaustive and highly illustrated installation and operation manual. Our technical experts are always available to answer our customer's questions.",
        },
        {
            question: "How do I select the right Liquid Ring Vacuum Pump for my application?",
            answer:
                "Contact PREMIER for a detailed system analysis to understand what size of Liquid Ring Vacuum Pump suits your process.",
        },

    ];
    const itemRefs = useRef([]);
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        const isOpen = openIndex === index;
        setOpenIndex(isOpen ? null : index);

        if (!isOpen) {
            // Scroll only if the item is not fully visible
            setTimeout(() => {
                const el = itemRefs.current[index];
                if (el) {
                    const rect = el.getBoundingClientRect();
                    const isOutOfView = rect.bottom > window.innerHeight;

                    if (isOutOfView) {
                        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }
            }, 100); // Timeout ensures DOM has rendered the expanded content
        }
    };

    // FAQ's

    // Brand Slider
    const brands = [
        { id: 1, image: require("../images/brands/bhel.png") },
        { id: 3, image: require("../images/brands/ntpc.png") },
        { id: 3, image: require("../images/brands/jindal.png") },
        { id: 4, image: require("../images/brands/adani.png") },
        { id: 4, image: require("../images/brands/tata-power.png") },
        { id: 5, image: require("../images/brands/dcm-sriram.png") },
        { id: 5, image: require("../images/brands/itc.png") },
        { id: 10, image: require("../images/brands/parrys.png") },
        { id: 10, image: require("../images/brands/bilt.jpeg") },
        { id: 14, image: require("../images/brands/spb.png") },
        { id: 13, image: require("../images/brands/balrampur.jpeg") },
        { id: 12, image: require("../images/brands/ucil.png") },
        { id: 15, image: require("../images/brands/irel.png") },
        { id: 16, image: require("../images/brands/arya.png") },
        // { id: 2, image: require("../images/brands/apgenco.png") },
        // { id: 11, image: require("../images/brands/tnpl.png") },
    ];

    // Brand Slider

    return (
        <div className=''>
            {loading && <FullScreenLoader label="Sending..." />}
            {/* Top Products Starts */}
            {/* <div className='row'>
              <div className='col-lg-6'></div>
              <div className='col-lg-6'></div>
            </div> */}
            {/* Popup */}
            {showFormPopup && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        <div className="popup-header d-flex justify-content-center align-items-center">
                            <h5 className=''>{pendingBrochure ? "Download Brochure" : "Reach Out to Us !"}</h5>
                            <button
                                className="btn-close fs-4"
                                onClick={closeBrochureForm}
                            >
                                ×
                            </button>
                        </div>

                        <div className="form-container">
                            {!formSubmitted ? (
                                <form onSubmit={handleSubmit}>
                                    <div className="input-group flex-column">

                                        {/* Full Name */}
                                        <label className="fw-medium">
                                            Name <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-wrapper rounded-20 my-1 p-2">
                                            <div className="d-flex align-items-center">
                                                <User size={20} className="input-icon text-blue me-2" />
                                                <input
                                                    id="fullName"
                                                    name="fullName"
                                                    type="text"
                                                    placeholder="Enter your name"
                                                    className="form-control border-start rounded-0 ps-2"
                                                    required
                                                    value={formData.fullName}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>

                                        {/* Email */}
                                        <label className="fw-medium">
                                            Email <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-wrapper rounded-20 my-1 p-2">
                                            <div className="d-flex align-items-center">
                                                <Mail size={20} className="input-icon text-blue me-2" />
                                                <input
                                                    id="email"
                                                    name="email"
                                                    type="email"
                                                    placeholder="Enter your email"
                                                    className="form-control border-start rounded-0 ps-2"
                                                    required
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>

                                        {/* Phone */}
                                        <label className="fw-medium">Phone</label>
                                        <div className="input-wrapper rounded-20 my-1 p-2">
                                            <div className="d-flex align-items-center">
                                                <Phone size={20} className="input-icon text-blue me-2" />
                                                <input
                                                    id="phone"
                                                    name="phone"
                                                    type="tel"
                                                    placeholder="Enter your phone number"
                                                    className="form-control border-start rounded-0 ps-2"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    onKeyDown={(e) => {
                                                        const allowedKeys = [
                                                            "Backspace", "ArrowLeft", "ArrowRight", "Delete",
                                                            "Tab", "Home", "End", "+", "-", "(", ")", " "
                                                        ];
                                                        const isNumber = /^[0-9]$/.test(e.key);
                                                        const isAllowed = allowedKeys.includes(e.key);
                                                        if (!isNumber && !isAllowed) e.preventDefault();
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Message */}
                                        <label className="fw-medium mt-3">Message</label>
                                        <div className="input-wrapper rounded-20 my-1 p-2">
                                            <textarea
                                                id="message"
                                                name="message"
                                                placeholder="Your Message"
                                                rows="4"
                                                className="form-control rounded-0 ps-2"
                                                required
                                                value={formData.message}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Submit */}
                                        <div className="d-flex justify-content-center">
                                            <button type="submit" className="btn btn-primary rounded-20 my-1 px-4 py-3">
                                                {loading ? "Sending..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>

                                    {responseMessage && <p className="text-center mt-3">{responseMessage}</p>}
                                </form>
                            ) : (
                                <div className="text-center p-4">
                                    <p>Thank you for reaching out! We'll get back to you soon.</p>
                                    <button className="btn btn-primary mt-3 px-4" onClick={() => {
                                        setShowFormPopup(false);
                                    }}>
                                        Close
                                    </button>
                                </div>
                            )}
                        </div>


                    </div>
                </div>
            )}

            {/* Popup */}

            {/* thank you popup  */}

            {showThankYouPopup && (
                <div className="thankyou-popup-overlay d-flex align-items-center justify-content-center" id="thankyou-popup-overlay">
                    <div className="thankyou-popup-box position-relative" id="thankyou-popup-box">
                        <div className="thankyou-popup-body text-center d-flex align-items-center justify-content-center flex-column">
                            {/* <h5 className="mb-3 fs-2">🎉 Thank You!</h5> */}
                            <h5 className="mb-3 fw-bold text-blue fs-3">Thank you for reaching out to us.</h5>
                            <p> You can also contact PREMIER at <a href='mailto:support@premierpumps.com' >support@premierpumps.com</a></p>
                            <button
                                className="btn btn-primary mt-3 px-4"
                                onClick={() => setShowThankYouPopup(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}


            {/* thank you popup  */}

            {/* categories slider start  */}
            <div className="container my-2">
                <div className="row w-100">
                    <div className="col-11">
                        <div className="">
                            <Swiper
                                autoplay={{
                                    delay: 2500,
                                    disableOnInteraction: false,
                                    pauseOnMouseEnter: true, // Stops on hover
                                }}
                                speed={1000}
                                loop={true}
                                slidesPerView={6}
                                spaceBetween={15}
                                modules={[Autoplay]}
                                breakpoints={{
                                    320: { slidesPerView: 3, spaceBetween: 10 },
                                    576: { slidesPerView: 3, spaceBetween: 15 },
                                    768: { slidesPerView: 5, spaceBetween: 20 },
                                    992: { slidesPerView: 8, spaceBetween: 25 },
                                }}
                            >
                                {products.map((product) => (
                                    <SwiperSlide key={product.id}>
                                        <div
                                            className="text-center d-flex flex-column h-100"
                                            onClick={() =>
                                                product.name === "SPARES"
                                                    ? handleReachOut("spares")
                                                    : navigate(`/product-details/${product.category}`)
                                            }
                                            style={{ cursor: "pointer" }}
                                        >
                                            <img
                                                src={product.image}
                                                alt={product.name}
                                                className={`top-series-img mb-2 ${product.name === "SPARES" ? "spares-img" : ""
                                                    }`}
                                                style={{
                                                    width: "100px",
                                                    height: "100px",
                                                    objectFit: "contain",
                                                    margin: "0 auto",
                                                }}
                                            />
                                            <p
                                                className={`mt-auto mb-0 top-series-title ${product.name === "SPARES" ? "spares-title" : ""
                                                    }`}
                                                style={{ fontSize: "14px" }}
                                            >
                                                {product.name}
                                            </p>
                                        </div>
                                    </SwiperSlide>
                                ))}

                            </Swiper>
                        </div>

                    </div>

                    <div className="col-1  text-center d-flex align-items-center justify-content-center">
                        <Link to="/products" className="all-button">
                            <div className=''>
                                <p className="plus-icon d-flex align-items-center justify-content-center">+</p>
                                <p className='mb-0'> All</p>
                            </div>
                        </Link>
                    </div>
                </div>
                {/*  */}

                {/*  */}
            </div>
            {/* categories slider start  */}


            {/* Top Products Ends*/}
            {/* Envision Starts */}
            <div className='container'>
                <div
                    id="carouselExampleIndicators"
                    className="carousel slide"
                    data-bs-ride="carousel"
                    data-bs-interval="5000" // Auto-slide every 3 seconds
                    data-bs-pause="false" // Prevent pausing on hover
                >
                    {/* Indicators */}
                    <div className='hero-indicators'>
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                        </div>
                    </div>

                    {/* Slides */}
                    <div className="carousel-inner">
                        {/* First Slide */}
                        <div className="carousel-item active h-100">
                            <div className="envision-main rounded h-100">
                                <div className="row align-items-center flex-wrap-reverse p-3">
                                    <div className="col-md-6 my-3 d-flex justify-content-end">
                                        <div className="envision-left text-md-start text-center">
                                            <h2 className="fs-1 text-white">Envision. Engineer. Execute.</h2>
                                            <div className="mt-md-5 mt-3">
                                                <button
                                                    onClick={() => handleReachOut("services")} // pass a context if needed
                                                    className="text-decoration-none text-white border border-white bg-transparent py-md-3 px-md-4 p-2 reach-button top-series-title"
                                                >
                                                    Reach Out to Us ! <span className="ms-md-4 ms-1"><MdKeyboardArrowRight size={20} /></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 my-3">
                                        <div className="envision-right d-flex justify-content-center">
                                            <img src={EnvisionOne} className="w-75" alt="Envision" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Second Slide */}
                        <div className="carousel-item h-100">
                            <div className="envision-main rounded h-100">
                                <div className="row align-items-center flex-wrap-reverse p-3">
                                    <div className="col-md-6 my-3 d-flex justify-content-center">
                                        <div className="envision-left text-md-start text-center">
                                            <h2 className="fs-1 text-white">Envision. Engineer. Execute.</h2>
                                            <div className="mt-md-5 mt-3">
                                                <button
                                                    onClick={() => handleReachOut("services")} // pass a context if needed
                                                    className="text-decoration-none text-white border border-white bg-transparent py-md-3 px-md-4 p-2 reach-button top-series-title"
                                                >
                                                    Reach Out to Us ! <span className="ms-md-4 ms-1"><MdKeyboardArrowRight size={20} /></span>
                                                </button>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 my-3">
                                        <div className="envision-right d-flex justify-content-center">
                                            <img src={EnvisionTwo} className="img-fluid" alt="Envision" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Envision Ends */}
            {/* Series Products Starts */}
            <div className="container">
                <div className='row flex-wrap-reverse'>
                    <div className='col-md-6 mt-3 text-md-start text-center'>
                        <div className='h-100 d-flex align-items-end justify-content-md-start justify-content-center'>
                            <h2 className=" mb-2 fw-bold">
                                Our Products
                            </h2>
                        </div>
                    </div>
                    <div className='col-md-6 mt-3'>
                        <div className="d-flex justify-content-md-end justify-content-center align-items-center h-100">
                            {/* <div className="card shadow-md p-md-4 p-2 fixed-whatsapp floating">
                                <div className="d-flex flex-md-column flex-row align-items-center justify-content-between gap-3 text-center text-md-start">
                                    <h6 className=" text-dark fw-bold fs-sm-14 mb-0">Let’s Stay Connected!</h6>
                                    <a
                                        href="https://wa.me/+916302388294"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn whatsapp-color text-white d-flex align-items-center justify-content-center fs-sm-14"

                                    >
                                        <FaWhatsapp size={24} className="me-2" />
                                        Link WhatsApp
                                    </a>
                                </div>
                            </div> */}
                            {/* <div className="contact-connect card shadow-md p-3 position-fixed end-0 fixed-whatsapp">
                                <div className="d-flex flex-md-column flex-row align-items-center justify-content-between gap-3 text-center text-md-start ">
                                    <h6 className=" text-dark fw-bold fs-12 mb-0">Let’s Stay <br /> Connected!</h6>
                                    <a
                                        href="https://wa.me/+916309333412"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn whatsapp-color text-white d-flex align-items-center justify-content-center fs-12"

                                    >
                                        <FaWhatsapp size={24} className="" />

                                    </a>
                                </div>
                            </div> */}

                        </div>
                    </div>
                </div>
                {/*  */}
                <div className=''>
                    {/* First Slider */}
                    <div className='mb-3'>
                        <div className="d-flex justify-content-end">
                            <button className="btn btn-outline-primary me-2 prev1 px-4 py-0 fs-5">&#8249;</button>
                            <button className="btn btn-outline-primary next1  px-4 py-0 fs-5">&#8250;</button>
                        </div>
                        {/* First Swiper */}
                        <Swiper
                            ref={swiper1Ref}
                            onSwiper={(swiper) => (swiper1Ref.current = swiper)}
                            modules={[Autoplay, Navigation]}
                            autoplay={{
                                delay: 2000,
                                disableOnInteraction: false,
                            }}
                            speed={1000}
                            loop={true}
                            slidesPerView={4}
                            spaceBetween={20}
                            navigation={{ nextEl: ".next1", prevEl: ".prev1" }}
                            breakpoints={{
                                320: { slidesPerView: 2 },
                                576: { slidesPerView: 2 },
                                768: { slidesPerView: 3 },
                                992: { slidesPerView: 4 },
                            }}
                            onMouseEnter={() => swiper1Ref.current?.autoplay.stop()}
                            onMouseLeave={() => swiper1Ref.current?.autoplay.start()}
                        >
                            {productItems1.map((product, index) => (
                                <SwiperSlide key={product.id}>
                                    <div className={`${index % 2 === 0 ? "even-card" : "odd-card"} p-md-3 p-1 product-slide-card rounded-15 text-center my-3`}>
                                        <Link to={`/product-details/${product.category}`} className="text-decoration-none">
                                            <div className="d-flex flex-column h-100 p-2 p-lg-4 justify-content-between">

                                                <h5 className="fw-bold text-white mb-3">{product.name}</h5>

                                                {product.capacity?.prefix && (
                                                    <div className='d-flex justify-content-center'>
                                                        <div className="product-capacity text-blue text-start" style={{ fontSize: "px", lineHeight: "1.4" }}>
                                                            {/* <p className='mb-0'>Capacity :</p> */}
                                                            <div dangerouslySetInnerHTML={{ __html: product.capacity.prefix }} className='fs-sm-12' />
                                                            <div dangerouslySetInnerHTML={{ __html: product.capacity.suffix }} className='fs-sm-12' />

                                                        </div>
                                                    </div>
                                                )}

                                                <img src={product.image} alt={product.name} className="card-img-top" />

                                                <a
                                                    href={product.brochure}
                                                    download={product.brochureName}
                                                    className="btn btn-outline-primary download-brochure mt-2 d-flex align-items-center mx-auto fs-sm-10"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        openBrochureForm(
                                                            product.brochure,
                                                            product.brochureName,
                                                            product.name
                                                        );
                                                    }}
                                                >
                                                    Download Brochure <FaArrowDown className="ms-2" size={14} />
                                                </a>

                                            </div>
                                        </Link>
                                    </div>
                                </SwiperSlide>
                            ))}

                        </Swiper>

                        {/* Second Swiper */}
                        <Swiper
                            ref={swiper2Ref}
                            onSwiper={(swiper) => (swiper2Ref.current = swiper)}
                            modules={[Autoplay, Navigation]}
                            autoplay={{
                                delay: 2000, // Same delay as first Swiper
                                disableOnInteraction: false,
                            }}
                            speed={1000}
                            loop={true}
                            slidesPerView={4}
                            spaceBetween={20}
                            navigation={{ prevEl: ".prev2", nextEl: ".next2" }}
                            breakpoints={{
                                320: { slidesPerView: 2 },
                                576: { slidesPerView: 2 },
                                768: { slidesPerView: 3 },
                                992: { slidesPerView: 4 },
                            }}
                            onMouseEnter={() => swiper2Ref.current?.autoplay.stop()}
                            onMouseLeave={() => swiper2Ref.current?.autoplay.start()}
                        >
                            {productItems2.map((product, index) => (
                                <SwiperSlide key={product.id}>
                                    <div className={`${index % 2 === 0 ? "even-card" : "odd-card"} p-md-3 p-1 product-slide-card rounded-15 text-center my-3`}>
                                        <Link to={`/product-details/${product.category}`} className="text-decoration-none">
                                            <div className="d-flex flex-column h-100 p-2 p-lg-4 justify-content-between">

                                                <h5 className="fw-bold text-white mb-3">{product.name}</h5>

                                                {product.capacity?.prefix && (
                                                    <div className='d-flex justify-content-center'>
                                                        <div className="product-capacity text-blue text-start" style={{ fontSize: "px", lineHeight: "1.4" }}>
                                                            {/* <p className='mb-0'>Capacity :</p> */}
                                                            <div dangerouslySetInnerHTML={{ __html: product.capacity.prefix }} className='fs-sm-12' />
                                                            <div dangerouslySetInnerHTML={{ __html: product.capacity.suffix }} className='fs-sm-12' />

                                                        </div>
                                                    </div>
                                                )}

                                                <img src={product.image} alt={product.name} className="card-img-top" />

                                                {product.brochure && (
                                                    <a
                                                        href={product.brochure}
                                                        download={product.brochureName}
                                                        className="btn btn-outline-primary download-brochure mt-2 d-flex align-items-center mx-auto fs-sm-10"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            openBrochureForm(
                                                                product.brochure,
                                                                product.brochureName,
                                                                product.name
                                                            );
                                                        }}
                                                    >
                                                        Download Brochure <FaArrowDown className="ms-2" size={14} />
                                                    </a>
                                                )}
                                            </div>
                                        </Link>
                                    </div>
                                </SwiperSlide>
                            ))}

                        </Swiper>
                    </div>

                    <div className="d-flex justify-content-end">
                        <button className="btn btn-outline-primary me-2 prev2 px-4 py-0 fs-5">&#8249;</button>
                        <button className="btn btn-outline-primary next2 px-4 py-0 fs-5">&#8250;</button>
                    </div>

                </div>
                {/*  */}
                {/* <h5 className='text-center mt-2 text-primary'>Explore our Wide variety Products </h5> */}
                <div className='d-flex justify-content-center mt-3'>
                    <Button
                        variant="outline-primary text-dark rounded"
                        className="ms-3 d-flex align-items-center py-2 px-4 fs-5 rounded"
                        onClick={handleNavigation}
                    >
                        Explore Our Products <ArrowUpRight size={18} className="ms-2" />
                    </Button>
                </div>
            </div>
            {/* Series Products Ends */}
            {/* Benefits Starts */}
            <Container className="container">

                <div className='row'>
                    <div className='col-lg-6 col-md-8'>
                        {/* <h2 className="fw-bold mb-0">Why Premier</h2> */}
                        {/* <p className="text-muted">Your advantages in the vacuum technology shop from Premier</p>
                        <hr /> */}
                    </div>

                </div>
                <Row className="align-items-center">
                    <img src={WhyPremierGif} />
                    {/* Image Section */}
                    <Col lg={6} className="text-center">
                        {/* <img
                            src={BenefitsImage}
                            alt="Power saved using Challenger Series"
                            className="img-fluid mt-5"
                        /> */}

                        <div className='row justify-content-center'>
                            <div className='col-md-10 '>
                                <div className='d-flex justify-content-center align-items-center'>
                                    <img src={BenefitOne} alt="TUV SUD" className="mx-2 benefit-img" style={{ height: "100px" }} />
                                    <img src={BenefitTwo} alt="ASTM Member" className="mx-2 benefit-img" style={{ height: "100px" }} />
                                    {/* <div className=''>
                                        <img src={BenefitThree} alt="Star Export House" className="mx-2 benefit-img" style={{ height: "100px" }} />
                                        <p className='fs-12 text-center fw-bold'>Government Of India Certified <br /> Star Export House</p>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </Col>

                    {/* Benefits List Section */}
                    <Col lg={6} className=''>
                        {/* <ul className="list-unstyled">
                            {benefits.map((benefit, index) => (
                                <li key={index} className="d-flex align-items-start mb-2">
                                    <div className="me-3">
                                        <span className="rounded-circle border border-dark d-flex justify-content-center align-items-center"
                                            style={{ width: "30px", height: "30px", fontSize: "16px", fontWeight: "bold" }}>
                                            {index + 1}
                                        </span>
                                    </div>
                                    <div>
                                        <h5 className="fw-bold">{benefit.title}</h5>
                                        <p className="text-muted">{benefit.description}</p>
                                    </div>
                                </li>
                            ))}
                        </ul> */}
                        {/* <img src={WhyRight} className='img-fluid p-4' /> */}
                        <div className='row align-items-center justify-content-center my-2'>
                            <div className='col-md-8 d-flex flex-wrap flex-md-nowrap  justify-content-md-start  justify-content-center'>
                                <p className="mb-0 fs-6">Premier can help you save your process cost !</p>
                                <Button variant="outline-primary text-dark rounded" onClick={() => handleReachOut("services")} className=" d-flex align-items-center py-2 px-4 fs-5 rounded my-md-0 my-2">
                                    Discover <ArrowUpRight size={18} className="ms-2" />
                                </Button>
                            </div>
                            {/* <div className='col-4 text-center d-flex justify-content-start my-2'>

                            </div> */}
                        </div>

                    </Col>
                </Row>
            </Container>
            {/*  /////////////*/}
            {/* // Test Certificates Section */}
            <div className="test-certificates-section container mt-4">
                {/* <p className="fs-12 fw-bold">
                    Test certificates and other reports will be given
                </p> */}
                <div className="row">
                    {[
                        {
                            icon: HighQualityIcon,
                            text: "Quality",
                        },
                        {
                            icon: OnTimeDeliveryIcon,
                            text: "On time Delivery",
                        },
                        {
                            icon: ClientsIcon,
                            text: "Installations in 40+ Countries",
                        },
                        {
                            icon: ComplianceIcon,
                            text: "Quality Compliance Documentation",
                        },
                    ].map((item, index) => (
                        <div key={index} className="col-lg-3 col-md-6 mb-3">
                            <div className="certificate-card p-3">
                                <div className='row align-items-center'>
                                    <div className='col-3'>
                                        <img
                                            src={item.icon}
                                            alt={item.text}
                                            className="certificate-icon"
                                        />
                                    </div>
                                    <div className='col-9'>
                                        <p className="certificate-text mb-0 fw-bold text-center">{item.text}</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {/* ////////// */}
            {/*  */}
            <div className="mt-4 container pb-lg-5" id="quality">
                <h2 className="text-start mt-4 mb-0 fw-bold">
                    Quality
                </h2>
                {/* <div className='scrolling-text my-4'> */}
                {/* <div className="scroll-line-wrapper">
                    <div className="scroll-line scroll-line-1 my-3">
                        <div className="scroll-track">
                            <span>In India, PREMIER operates with a 30,000 sq. ft. workshop and 3,000 sq. ft. office space. &nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <span>In India, PREMIER operates with a 30,000 sq. ft. workshop and 3,000 sq. ft. office space. &nbsp;&nbsp;&nbsp;&nbsp;</span>
                        </div>
                    </div>

                    <div className="scroll-line scroll-line-2 my-3">
                        <div className="scroll-track">
                            <span>In the USA, PREMIER has a dedicated 10,000 sq. ft. warehouse for North and South American markets. &nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <span>In the USA, PREMIER has a dedicated 10,000 sq. ft. warehouse for North and South American markets. &nbsp;&nbsp;&nbsp;&nbsp;</span>
                        </div>
                    </div>
                </div> */}


                {/* </div> */}

                {/* First Swiper Slider */}
                <div className="mb-3">
                    <div className="d-flex justify-content-end mb-3 d-lg-none d-block">
                        <button className="btn btn-outline-primary me-2 prev1 px-4 py-0 fs-5">&#8249;</button>
                        <button className="btn btn-outline-primary next1 px-4 py-0 fs-5">&#8250;</button>
                    </div>
                    <Swiper
                        autoplay={{ delay: 2500, disableOnInteraction: false }}
                        speed={1000}
                        modules={[Navigation]}
                        loop={true}
                        slidesPerView={4}
                        spaceBetween={20}
                        navigation={{ nextEl: ".next1", prevEl: ".prev1" }}
                        breakpoints={{
                            320: { slidesPerView: 2 },
                            576: { slidesPerView: 2 },
                            768: { slidesPerView: 3 },
                            992: { slidesPerView: 4 },
                        }}
                    >
                        {services1.map((service, index) => (
                            <SwiperSlide key={index}>
                                <div className="text-center p-3">
                                    <div className='facility-card'>
                                        <img src={service.image} alt={service.title} className="img-fluid mb-3" />
                                        <h5>{service.title}</h5>
                                        <p
                                            className="text-muted fs-12"
                                            dangerouslySetInnerHTML={{ __html: service.description }}
                                        ></p>

                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                {/* Second Swiper Slider */}
                <div className="mb-3">

                    <Swiper
                        autoplay={{ delay: 2500, disableOnInteraction: false }}
                        speed={1000}
                        modules={[Navigation]}
                        loop={true}
                        slidesPerView={4}
                        spaceBetween={20}
                        navigation={{ prevEl: ".prev2", nextEl: ".next2" }}
                        breakpoints={{
                            320: { slidesPerView: 2 },
                            576: { slidesPerView: 2 },
                            768: { slidesPerView: 3 },
                            992: { slidesPerView: 4 },
                        }}
                    >
                        {services2.map((service, index) => (
                            <SwiperSlide key={index}>
                                <div className="text-center p-3">
                                    <div className='facility-card'>
                                        <img src={service.image} alt={service.title} className="img-fluid mb-3" />
                                        <h5>{service.title}</h5>
                                        <p className="text-muted fs-12">{service.description}</p>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <div className="d-flex justify-content-end d-lg-none d-block">
                        <button className="btn btn-outline-primary me-2 prev2 px-4 py-0 fs-5">&#8249;</button>
                        <button className="btn btn-outline-primary next2 px-4 py-0 fs-5">&#8250;</button>
                    </div>
                </div>

                <div className='row justify-content-center'>
                    <div className='col-lg-3 col-md-8'>
                        <h5 className='text-center text-blue mb-2'>Discover how best in class Pumps are made</h5>
                        <div className='d-flex justify-content-center mt-4'>
                            <Button variant="outline-primary text-dark rounded" onClick={() => handleReachOut("services")} className="ms-3 d-flex align-items-center py-2 px-4 fs-5 rounded">
                                Our process <ArrowUpRight size={18} className="ms-2" />
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            {/*  */}
            {/* Services Ends */}
            {/* // Our Services Section */}
            <div className="our-services-section container mt-4" id='services'>
                <h2 className="section-heading">Our Services</h2>
                <div className="row">
                    {[
                        {
                            icon: FieldServicesIcon,
                            title: "Field Services",
                            description: "Unexpected breakdowns of Liquid Ring Vacuum Pumps can disrupt your production line. PREMIER can swiftly address these emergencies and minimize downtime by providing on-site maintenance for your pumps.",
                        },
                        {
                            icon: VacuumSystemIcon,
                            title: "Vacuum Systems Audit",
                            description: "PREMIER offers on-site audits of your Liquid Ring Vacuum Pumps and Systems with minimal process downtime, providing you with valuable pump efficiency data and pipe layout recommendations to optimize energy consumption.",
                        },
                        {
                            icon: MaintenanceRepairIcon,
                            title: "Maintenance & Repair",
                            description: "With PREMIER's repair and reconditioning services, extend the service life of your Liquid Ring Vacuum Pump and get the most out of your pump investment.",
                        },
                        {
                            icon: CommissioningTrainingIcon,
                            title: "Commissioning and Training support",
                            description: "PREMIER provides on-site commissioning assistance as well as training in operation and maintenance for Liquid Ring Vacuum Pumps.",
                        },
                    ].map((service, index) => (
                        <div key={index} className="col-lg-3 col-md-6 col-sm-12 mb-4">
                            <div className="service-card px-4 py-5 text-center">
                                <img
                                    src={service.icon}
                                    alt={service.title}
                                    className="service-icon mb-4"
                                />
                                <h3 className="service-title text-blue mb-3 fs-4">{service.title}</h3>
                                <p className="service-description">{service.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {/* our services section */}

            {/* Testimonial Slide Starts */}
            {/* <section className="testimonial-section py-5 container">
                <div className="container">
                    <div className='row'>
                        <div className='col-lg-4 col-md-8 col-10'>

                            <h2 className="text-start my-3 fw-bold">
                                What Our Clients Say
                            </h2>
                        </div>

                    </div>
                    <div id="testimonialCarousel" className="carousel slide" data-bs-ride="carousel">

                        <div className="carousel-inner py-3 testi-carousel">
                            {testimonials.map((testimonial, index) => (
                                <div key={testimonial.id} className={`carousel-item ${index === 0 ? "active" : ""}`}>
                                    <div className="row align-items-center justify-content-center">
                                        <div className="col-md-3 d-flex justify-content-center">
                                            <img src={testimonial.logo} alt="Client Logo" className="testimonial-logo img-fluid mb-3" />
                                        </div>
                                        <div className="col-md-7 testi-carousel-content d-flex align-items-center">
                                            <div>
                                                <p className="testimonial-text fs-5 text-md-start text-center">{testimonial.text}</p>
                                                <div className="d-flex align-items-center mt-3 justify-content-md-start justify-content-center">
                                                    <img
                                                        src={testimonial.authorImg}
                                                        alt={testimonial.authorName}
                                                        className="rounded-circle me-2"
                                                        width="60"
                                                        height="60"
                                                    />
                                                    <div>
                                                        <h6 className="mb-0 fw-semibold fs-5">{testimonial.authorName}</h6>
                                                        <p className="text-muted mb-0 fs-6">{testimonial.authorRole}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>


                        <div className='testi-indiactors'>
                            <div className="carousel-indicators mt-3">
                                {testimonials.map((_, index) => (
                                    <button
                                        key={index}
                                        type="button"
                                        data-bs-target="#testimonialCarousel"
                                        data-bs-slide-to={index}
                                        className={index === 0 ? "active" : ""}
                                        aria-label={`Slide ${index + 1}`}
                                    ></button>
                                ))}
                            </div>
                        </div>


                        <button className="carousel-control-prev" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        </button>
                    </div>
                </div>
            </section>
            <p className="text-center mt-2 disclaimer-text text-blue container">
                All brand logos are the property of their respective owners and used here for reference purposes only.
            </p> */}
            {/* Testimonial Slide Ends */}
            {/* Advantange Slide Starts */}
            <div className="w-full max-w-7xl mx-auto container">
                <div className='row'>
                    <div className='col-lg-6 col-md-8'>
                        {/* <hr /> */}
                        <h2 className="text-start my-4 fw-bold">
                            Industries
                        </h2>
                    </div>

                </div>

                <div className="relative">
                    {/* Swiper Container */}
                    <Swiper
                        slidesPerView={5}
                        spaceBetween={20}
                        loop={true} // Enable infinite sliding
                        autoplay={{ delay: 3000, disableOnInteraction: false }} // Auto-slide every 3s
                        speed={1000}
                        breakpoints={{
                            320: { slidesPerView: 2 },
                            576: { slidesPerView: 2 },
                            768: { slidesPerView: 3 },
                            992: { slidesPerView: 5 },
                        }}
                        navigation={{ // ✅ Enable Custom Navigation
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        }}
                        modules={[Navigation, Autoplay]}
                        className="w-full"
                    >
                        {advantageItems.map((item, index) => (
                            <SwiperSlide key={index} className="text-center">
                                <img src={item.image} alt={item.title} className="rounded-lg advantage-img" />
                                <p className="mt-2 text-blue fw-bold">{item.title}</p>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    {/* Custom Navigation Buttons */}
                    <div className="d-flex justify-content-end mt-3">
                        <button className="btn btn-outline-primary me-2 swiper-button-prev">
                            &#8249;
                        </button>
                        <button className="btn btn-outline-primary swiper-button-next">
                            &#8250;
                        </button>
                    </div>
                </div>
            </div>
            {/* Advantange Slide Ends */}
            {/* Latest Writing */}
            <div className="latest-writing-section mb-5">
                <div className="container">
                    <h3 className="fw-bold mb-4">Latest Writing</h3>
                    <Swiper
                        ref={swiper1Ref}
                        onSwiper={(swiper) => (swiper1Ref.current = swiper)}
                        modules={[Autoplay, Navigation]}
                        autoplay={{
                            delay: 2000,
                            disableOnInteraction: false,
                        }}
                        speed={1000}
                        loop={true}
                        slidesPerView={4}
                        spaceBetween={20}
                        navigation={{ nextEl: ".next1", prevEl: ".prev1" }}
                        breakpoints={{
                            320: { slidesPerView: 1 },
                            576: { slidesPerView: 2 },
                            768: { slidesPerView: 2 },
                            992: { slidesPerView: 3 },
                        }}
                        onMouseEnter={() => swiper1Ref.current?.autoplay.stop()}
                        onMouseLeave={() => swiper1Ref.current?.autoplay.start()}
                    >
                        {writingItems.map((item) => {
                            const plainText = item.description.replace(/<\/?[^>]+(>|$)/g, "");
                            const shortText = plainText.length > 80 ? plainText.substring(0, 80) + "..." : plainText;

                            return (
                                <SwiperSlide key={item.id} className="h-100">
                                    <Link
                                        to={`/writing-details/${item.id}`}
                                        state={{
                                            name: item.name,
                                            date: item.date,
                                            description: item.description,
                                            image: item.image
                                        }}
                                        className="text-decoration-none h-100 d-block"
                                    >
                                        <div className="writing-slide-card bg-white shadow-sm h-100">
                                            <div className="d-flex flex-column h-100">
                                                <img
                                                    src={item.image}
                                                    alt={item.name}
                                                    className="card-img-top mx-auto rounded-3"
                                                />

                                                <div className="card-body mt-auto p-3 fs-sm-12">
                                                    {/* <p className="">{item.date}</p> */}
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <p className="mb-0 text-dark small flex-grow-1 me-3">{shortText}</p>
                                                        <ArrowUpRight size={20} className="text-blue flex-shrink-0" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>

                    {/* Custom Navigation Buttons */}
                    <div className="d-flex justify-content-end mt-4">
                        <button className="btn btn-outline-primary me-2 prev1 px-4 py-0 fs-5">&#8249;</button>
                        <button className="btn btn-outline-primary next1  px-4 py-0 fs-5">&#8250;</button>
                    </div>
                    <div className='text-center d-flex justify-content-center'>
                        <Link to="/news" className="text-decoration-none">
                            <Button
                                variant="outline-primary text-dark rounded"
                                className="d-flex align-items-center py-2 px-4 fs-5 rounded my-md-0 my-2"
                            >
                                View All <ArrowUpRight size={18} className="ms-2" />
                            </Button>
                        </Link>

                    </div>


                </div>
            </div>
            {/* Latest Writing */}
            {/* Brand Slider */}
            {/* <div className='brand-slider container-fluid'>
                <Swiper
                    modules={[Autoplay]}
                    autoplay={{
                        delay: 2000,
                        disableOnInteraction: false,
                    }}
                    loop={true}
                    speed={1000}
                    spaceBetween={20}
                    slidesPerView={5}
                    breakpoints={{
                        320: { slidesPerView: 3, spaceBetween: 10 },
                        480: { slidesPerView: 3, spaceBetween: 10 },
                        768: { slidesPerView: 4, spaceBetween: 15 },
                        992: { slidesPerView: 5, spaceBetween: 20 },
                        1200: { slidesPerView: 6, spaceBetween: 25 },
                    }}
                >
                    {brands.map((brand) => (
                        <SwiperSlide key={brand.id}>
                            <div className="brand-logo-container">
                                <img
                                    src={brand.image}
                                    alt={`Brand ${brand.id}`}
                                    className="brand-logo"
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                <p className="text-center mt-4 disclaimer-text text-blue">
                    All brand logos are the property of their respective owners and used here for reference purposes only.
                </p>
            </div> */}
            {/* Brand Slider */}
            {/* Explore Starts */}
            {/* // Subscribe Newsletter Section */}
            <div className="subscribe-newsletter-section my-md-5 my-0">
                <div className="container py-3">
                    <div className="subscribe-inner">
                        <div className="row align-items-center justify-content-between">
                            <div className="col-lg-3 col-md-3 col-sm-12 text-center text-md-start mb-3 mb-md-0">
                                <img
                                    src={SubscribeIcon}
                                    alt="Subscribe Icon"
                                    className="subscribe-icon img-fluid floating"
                                />
                            </div>
                            <div className="col-lg-6 col-md-9 col-sm-12">
                                <div className="subscribe-content">
                                    <h3 className="subscribe-heading mb-3 fw-bold text-md-start text-center">
                                        Subscribe Newsletter
                                    </h3>
                                    <form onSubmit={handleNewsletterSubmit}>
                                        <div className="d-flex align-items-center justify-content-md-start justify-content-center position-relative">
                                            <input
                                                type="email"
                                                placeholder="Enter your email"
                                                value={newsletterEmail}
                                                onChange={(e) => setNewsletterEmail(e.target.value)}
                                                required
                                                className="form-control subscribe-input me-2 py-4 bg-white border-0 rounded-15"
                                            />
                                            <button
                                                type="submit"
                                                className="btn subscribe-button py-2 fs-5 px-4 position-absolute end-0 me-3"
                                            >
                                                <i className="fa-regular fa-envelope me-md-4 me-2 fs-4"></i>
                                                Subscribe
                                            </button>
                                        </div>
                                    </form>
                                    {newsletterStatus && <p>{newsletterStatus}</p>}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Explore Ends */}
            {/* FAQ's */}
            <section className="container py-5">
                {/* Heading */}
                <div className="text-center mb-4">
                    <h2 className="fw-bold text-dark display-5">Frequently Asked Questions</h2>
                    {/* <p className="text-muted">We have put together some commonly asked questions</p> */}
                </div>

                {/* FAQ List */}
                <div className='row justify-content-center'>
                    <div className='col-lg-8'>
                        <div className="accordion" id="faqAccordion">
                            {faqs.map((faq, index) => (
                                <div
                                    className="accordion-item border-bottom border-0 mb-3 rounded"
                                    key={index}
                                    ref={(el) => (itemRefs.current[index] = el)}
                                >
                                    <h2 className="accordion-header">
                                        <button
                                            className={`accordion-button d-flex align-items-center bg-white text-dark fw-bold ${openIndex === index ? "" : "collapsed"}`}
                                            type="button"
                                            onClick={() => toggleFAQ(index)}
                                        >
                                            {faq.question}
                                            <FaChevronDown
                                                className={`ms-auto transition-transform ${openIndex === index ? "rotate-icon" : ""}`}
                                                style={{ transition: 'transform 0.3s ease' }}
                                            />
                                        </button>
                                    </h2>
                                    <div
                                        className={`accordion-collapse collapse ${openIndex === index ? "show" : ""}`}
                                        data-bs-parent="#faqAccordion"
                                    >
                                        <div
                                            className="accordion-body custom-scroll"
                                            dangerouslySetInnerHTML={{ __html: faq.answer }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="text-center mt-3">
                            <Link to="/faqs" className=" text-blue fw-semibold">
                                View All
                            </Link>
                        </div>

                    </div>
                </div>


                {/* Contact Us Section */}
                <div className="text-center mt-4">
                    <div className='row justify-content-center'>
                        <div className='col-lg-5'>
                            <p className=" bg-light p-2 rounded-pill border">
                                Didn’t find what you’re looking for?{" "}
                                <button onClick={() => handleReachOut("services")} className='border-0 text-danger fw-semibold text-decoration-underline' >Contact Us</button>
                            </p>
                        </div>
                    </div>

                </div>
            </section>
            {/* FAQ's */}
        </div >
    )
}

export default Home
